import { z } from 'zod';

export const agreementSchema = {
  required: z.object({
    fullName: z.string().min(1, 'Full name is required'),
    dateSigned: z.date({ required_error: 'Date signed is required' }),
    agreed: z.boolean().refine((val) => val === true, {
      message: 'You must agree to this before continuing',
    }),
  }),
  optional: z.object({
    fullName: z.string().optional(),
    dateSigned: z.date().optional(),
    agreed: z.boolean(),
  }),
};
export type AgreementFormValues = z.infer<(typeof agreementSchema)['required']> | z.infer<(typeof agreementSchema)['optional']>;

export const defaultValues: AgreementFormValues = {
  fullName: '',
  dateSigned: new Date(),
  agreed: false,
};
